// extracted by mini-css-extract-plugin
export default {"phaseSection":"progressDots_phaseSection__BSg8l"};